import { reactLocalStorage } from "reactjs-localstorage"
import ApiService from '../data/services/ApiService'

export const getServerMessage = (error, fallback) => {
    return error?.response?.data?.message || fallback
}

export const applyAuthSession = (responseData, onLoginSuccess) => {
    if (!responseData?.token || !responseData?.profile?.user) {
        throw new Error('Invalid auth session profile')
    }

    reactLocalStorage.set("token", responseData.token)
    reactLocalStorage.setObject("profile", responseData.profile)

    if (window.analytics && responseData.profile?.user?._id) {
        window.analytics.identify(responseData.profile.user._id, {
            name: `${responseData.profile.user.nombre}`,
            email: responseData.profile.user.email,
            empresa: responseData.profile.empresa?.nombre
        })
    }

    if (onLoginSuccess) {
        onLoginSuccess(responseData.profile)
    }
}

export const seleccionarEmpresaActiva = async ({ empresaId, selectionToken, onLoginSuccess }) => {
    const response = selectionToken
        ? await ApiService.seleccionarEmpresa({ selectionToken })
        : await ApiService.cambiarEmpresa({ empresaId })

    if (response.data?.success && response.data?.token && response.data?.profile) {
        applyAuthSession(response.data, onLoginSuccess)
    }

    return response
}

export const fetchMisEmpresas = async () => {
    const response = await ApiService.getMisEmpresas()
    return response.data?.data?.empresas || []
}

export const fetchContadores = async (empresaId) => {
    const response = await ApiService.getContadores(empresaId)
    return response.data?.data?.contadores || []
}

export const invitarContador = async (empresaId, { email, nombre }) => {
    return await ApiService.invitarContador(empresaId, { email, nombre })
}

export const removerContador = async (empresaId, userId) => {
    return await ApiService.removerContador(empresaId, userId)
}

export const verificarInvitacion = async (token) => {
    return await ApiService.verificarInvitacion(token)
}

export const aceptarInvitacionEmpresa = async ({ token, password }) => {
    return await ApiService.aceptarInvitacionEmpresa({ token, password })
}

export const reenviarInvitacion = async (empresaId, userId) => {
    return await ApiService.reenviarInvitacion(empresaId, userId)
}
